module.exports = __webpack_public_path__ + "media/1C_ResourceModel.6b3180d0.mp4";